/* __next_internal_client_entry_do_not_use__ LeanBrandTileRendererBase auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_array } from "@swc/helpers/_/_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { buildCategoryNavigationPath } from "@faire/retailer-shared/categories/navigationPath";
import { getLocationOrThrow } from "@faire/web--source/common/globals/getLocation";
import { optimizeImageUrl } from "@faire/web--source/common/images/optimizeImages";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web--source/common/localization/localize";
import { pathMatchesRoute } from "@faire/web--source/common/routes/RouteMatcher";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { trackEvent } from "@faire/web--source/common/trackEvent";
import { Column } from "@faire/web--source/slate/Layout";
import { LoadingSkeleton } from "@faire/web--source/slate/LoadingSkeleton";
import { trackRetailerPortalCategoryPageBrandTileClick } from "@faire/web-api--source/events/retailerPortal/click/categoryPageBrandTile";
import { trackRetailerPortalDiscoverPageBrandTileClick } from "@faire/web-api--source/events/retailerPortal/click/discoverPageBrandTile";
import { trackSeoCategoryBrandListBrandLinkRefsClick } from "@faire/web-api--source/events/seo/click/categoryBrandListBrandLinkRefs";
import { route as exploreRoute } from "@faire/web-api--source/routes/explore/searchTerm";
import pickBy from "lodash/pickBy";
import { observer } from "mobx-react";
import * as React from "react";
import { useCallback, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { FavoriteButton } from "@faire/retailer/components/Favorite/FavoriteButton";
import { BrandTileBadge } from "@faire/retailer/components/LeanBrandTileRenderer/__internal__/BrandTileBadge";
import { BrandTileImageSection } from "@faire/retailer/components/LeanBrandTileRenderer/__internal__/BrandTileImageSection";
import { LeanBrandTileStyles } from "@faire/retailer/components/LeanBrandTileRenderer/LeanBrandTileStyles";
import { getPromoBannerStyle } from "@faire/retailer/features/Events/utils";
import { followBrand, unFollowBrand } from "@faire/retailer/features/RetailerBoards/utils";
import { useIsLoggedInRetailer } from "@faire/retailer/lib/isLoggedInRetailer";
import { popSignUp, SignUpType } from "@faire/retailer/lib/popSignUp";
import { brandPage, isFromCategoryURL, isFromDiscoverURL } from "@faire/retailer/paths";
import { isNewCategory } from "@faire/retailer/services/Categories";
var LeanBrandTileRendererBaseCore = function(param) {
    var brandTile = param.brandTile, categoryUrlIdList = param.categoryUrlIdList, filterKeys = param.filterKeys, favoriteBrand = param.favoriteBrand, unFavoriteBrand = param.unFavoriteBrand, className = param.className, brandPageQueryParams = param.brandPageQueryParams, eventId = param.eventId, onClick = param.onClick, title = param.title, pageType = param.pageType, customButton = param.customButton, withoutFavourite = param.withoutFavourite, transparentFeaturedPromoTextBackground = param.transparentFeaturedPromoTextBackground, bottomPadding = param.bottomPadding, topPadding = param.topPadding, showMinimum = param.showMinimum, signUpTracking = param.signUpTracking, previousOrders = param.previousOrders;
    var _brandTile_brand, _brandTile_brand1;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _useState = _sliced_to_array(useState(!!(brandTile === null || brandTile === void 0 ? void 0 : (_brandTile_brand = brandTile.brand) === null || _brandTile_brand === void 0 ? void 0 : _brandTile_brand.is_following)), 2), internalFavorite = _useState[0], setInternalFavorite = _useState[1];
    var isSSR = useIsSSR();
    var isLoggedInRetailer = useIsLoggedInRetailer();
    var history = useHistory();
    var productTile = React.useRef(null);
    var brand = brandTile === null || brandTile === void 0 ? void 0 : brandTile.brand;
    var isLoaded = !!brand;
    var extendQueryParams = useCallback(function(baseParams) {
        if (!categoryUrlIdList) {
            return baseParams !== null && baseParams !== void 0 ? baseParams : {};
        }
        // logged out users should not see ref parameters (SEO requirement)
        var _$param = isLoggedInRetailer ? {
            refC: buildCategoryNavigationPath(categoryUrlIdList),
            refF: filterKeys,
            sortingHint: true
        } : {};
        return _object_spread({}, pickBy(_object_spread({}, _$param)), baseParams !== null && baseParams !== void 0 ? baseParams : {});
    }, [
        categoryUrlIdList,
        filterKeys,
        isLoggedInRetailer
    ]);
    var queryParams = useMemo(function() {
        if (brandPageQueryParams === undefined) {
            return extendQueryParams({});
        }
        return brandPageQueryParams(extendQueryParams);
    }, [
        brandPageQueryParams,
        extendQueryParams
    ]);
    var link = useMemo(function() {
        return (brand === null || brand === void 0 ? void 0 : brand.token) && brandPage(brand.token, queryParams);
    }, [
        brand === null || brand === void 0 ? void 0 : brand.token,
        queryParams
    ]);
    var carouselImages = useMemo(function() {
        if (!(brandTile === null || brandTile === void 0 ? void 0 : brandTile.brand)) {
            return [];
        }
        return brandTile.images.map(function(image) {
            return _object_spread_props(_object_spread({}, image), {
                url: optimizeImageUrl(image, isSSR, {
                    crop: {
                        smartSquare: true
                    },
                    ignoreResizeTag: true
                }),
                name: image.alt_text
            });
        });
    }, [
        brandTile === null || brandTile === void 0 ? void 0 : brandTile.brand,
        brandTile === null || brandTile === void 0 ? void 0 : brandTile.images,
        isSSR
    ]);
    var onLinkClick = useCallback(function() {
        var showReviews = !pathMatchesRoute(getLocationOrThrow().href, exploreRoute) && !isLoggedInRetailer;
        onClick === null || onClick === void 0 ? void 0 : onClick(brand === null || brand === void 0 ? void 0 : brand.token);
        var tileType = showReviews ? "REVIEW" : "BRAND_STORY";
        if (isFromDiscoverURL(getLocationOrThrow().pathname)) {
            trackRetailerPortalDiscoverPageBrandTileClick(tileType);
        } else if (isFromCategoryURL(getLocationOrThrow().pathname)) {
            trackRetailerPortalCategoryPageBrandTileClick(tileType);
        }
        if (!eventId) {
            return;
        }
        trackEvent("/maker-tile/link/".concat(eventId));
        var _ref = _to_array(categoryUrlIdList !== null && categoryUrlIdList !== void 0 ? categoryUrlIdList : []), c1UrlId = _ref[0], subCategoryUrlIds = _ref.slice(1);
        var _brand_token, _buildCategoryNavigationPath;
        trackSeoCategoryBrandListBrandLinkRefsClick((_brand_token = brand === null || brand === void 0 ? void 0 : brand.token) !== null && _brand_token !== void 0 ? _brand_token : "", c1UrlId !== null && c1UrlId !== void 0 ? c1UrlId : "", (_buildCategoryNavigationPath = buildCategoryNavigationPath(subCategoryUrlIds)) !== null && _buildCategoryNavigationPath !== void 0 ? _buildCategoryNavigationPath : "");
    }, [
        brand === null || brand === void 0 ? void 0 : brand.token,
        categoryUrlIdList,
        eventId,
        onClick,
        isLoggedInRetailer
    ]);
    var _getPromoBannerStyle = getPromoBannerStyle(brand === null || brand === void 0 ? void 0 : brand.is_highlighted_brand_for_promotional_event), lightBackground = _getPromoBannerStyle.lightBackground, promoText = _getPromoBannerStyle.promoText;
    var handleFavoriteOnClick = function() {
        var _brandTile_brand;
        if (!(brandTile === null || brandTile === void 0 ? void 0 : (_brandTile_brand = brandTile.brand) === null || _brandTile_brand === void 0 ? void 0 : _brandTile_brand.token)) {
            return;
        }
        var sourceId = (signUpTracking === null || signUpTracking === void 0 ? void 0 : signUpTracking.sourceId) ? "".concat(signUpTracking === null || signUpTracking === void 0 ? void 0 : signUpTracking.sourceId, "_") : "";
        if (!isLoggedInRetailer) {
            popSignUp(history, SignUpType.GENERIC, function() {
                return null;
            }, _object_spread_props(_object_spread({}, signUpTracking), {
                sourceId: "".concat(sourceId, "_brand_tile")
            }));
            return;
        }
        if (internalFavorite) {
            (unFavoriteBrand !== null && unFavoriteBrand !== void 0 ? unFavoriteBrand : unFollowBrand)(brandTile === null || brandTile === void 0 ? void 0 : brandTile.brand.token);
        } else {
            var _brandTile_brand_name;
            (favoriteBrand !== null && favoriteBrand !== void 0 ? favoriteBrand : followBrand)(brandTile.brand.token, (_brandTile_brand_name = brandTile.brand.name) !== null && _brandTile_brand_name !== void 0 ? _brandTile_brand_name : "");
        }
        setInternalFavorite(!internalFavorite);
    };
    var _brand_token, _brand_is_first_order, _brandTile_promo_text, _brand_token1;
    return /*#__PURE__*/ _jsx(LeanBrandTileStyles.Wrapper, {
        className: className,
        "data-test-id": isLoaded ? "maker-tile" : "maker-tile-placeholder",
        ref: productTile,
        children: /*#__PURE__*/ _jsxs(LeanBrandTileStyles.Wrapper, {
            $border: !isLoggedInRetailer,
            children: [
                /*#__PURE__*/ _jsxs(FullWidthWrapper, {
                    children: [
                        isLoaded ? /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(BrandTileImageSection, {
                                    title: title,
                                    pageType: pageType,
                                    token: (_brand_token = brand === null || brand === void 0 ? void 0 : brand.token) !== null && _brand_token !== void 0 ? _brand_token : "",
                                    images: carouselImages,
                                    linkLocation: link,
                                    name: brand === null || brand === void 0 ? void 0 : brand.name,
                                    eventPath: "/non-treasure-hunt/maker-tile/fade-carousel",
                                    onLinkClick: onLinkClick,
                                    brandProductImages: (_brandTile_brand1 = brandTile.brand) === null || _brandTile_brand1 === void 0 ? void 0 : _brandTile_brand1.product_images
                                }),
                                /*#__PURE__*/ _jsx(ImageAndButtonContainer, {
                                    children: customButton && isLoaded ? /*#__PURE__*/ _jsx(CustomButtonContainer, {
                                        children: customButton
                                    }) : null
                                })
                            ]
                        }) : /*#__PURE__*/ _jsx(LoadingSkeleton, {
                            width: "100%",
                            height: "",
                            aspectRatio: "1"
                        }),
                        /*#__PURE__*/ _jsx(LeanBrandTileStyles.NameAndMore, {
                            name: brand === null || brand === void 0 ? void 0 : brand.name,
                            brand: brand,
                            linkLocation: link,
                            minimum_order_amount: brand === null || brand === void 0 ? void 0 : brand.minimum_order_amount,
                            isFirstOrder: (_brand_is_first_order = brand === null || brand === void 0 ? void 0 : brand.is_first_order) !== null && _brand_is_first_order !== void 0 ? _brand_is_first_order : true,
                            hasNewProducts: (brand === null || brand === void 0 ? void 0 : brand.has_new_products) && !isNewCategory(categoryUrlIdList === null || categoryUrlIdList === void 0 ? void 0 : categoryUrlIdList[0]),
                            promoText: (_brandTile_promo_text = brandTile === null || brandTile === void 0 ? void 0 : brandTile.promo_text) !== null && _brandTile_promo_text !== void 0 ? _brandTile_promo_text : undefined,
                            promoTextColor: promoText,
                            promoTextBackground: transparentFeaturedPromoTextBackground ? "transparent" : lightBackground,
                            token: (_brand_token1 = brand === null || brand === void 0 ? void 0 : brand.token) !== null && _brand_token1 !== void 0 ? _brand_token1 : "",
                            onLinkClick: onLinkClick,
                            isLoggedIn: isLoggedInRetailer,
                            brandPromoLabel: brandTile === null || brandTile === void 0 ? void 0 : brandTile.brand_promo_label,
                            featuredBrandPromoLabel: brandTile === null || brandTile === void 0 ? void 0 : brandTile.featured_brand_promo_label,
                            review: brandTile === null || brandTile === void 0 ? void 0 : brandTile.review,
                            brandUrl: link,
                            bottomPadding: bottomPadding,
                            topPadding: topPadding,
                            showMinimum: showMinimum,
                            previousOrders: previousOrders
                        }),
                        (brandTile === null || brandTile === void 0 ? void 0 : brandTile.brand) ? /*#__PURE__*/ _jsx(BrandTileBadge, {
                            tile: brandTile
                        }) : null
                    ]
                }),
                isLoggedInRetailer && brand && !withoutFavourite ? /*#__PURE__*/ _jsx(FavoriteWrapper, {
                    children: /*#__PURE__*/ _jsx(FavoriteButton, {
                        ariaLabel: internalFavorite ? strictLocalize({
                            id: "Rwk4tg",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Un-follow "
                                },
                                {
                                    type: 1,
                                    value: "brandName"
                                }
                            ]
                        }, DEPRECATED_backwardsCompatibleValues({
                            brandName: brand.name
                        })) : strictLocalize({
                            id: "6HJ3eA",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Follow "
                                },
                                {
                                    type: 1,
                                    value: "brandName"
                                }
                            ]
                        }, DEPRECATED_backwardsCompatibleValues({
                            brandName: brand.name
                        })),
                        onClick: handleFavoriteOnClick,
                        favorited: internalFavorite
                    })
                }) : null
            ]
        })
    });
};
var ImageAndButtonContainer = styled.div.withConfig({
    componentId: "sc-39b31ae8-0"
})([
    "position:relative;width:100%;display:flex;justify-content:center;"
]);
var CustomButtonContainer = styled.div.withConfig({
    componentId: "sc-39b31ae8-1"
})([
    "position:absolute;z-index:1;bottom:0;"
]);
var FavoriteWrapper = styled.div.withConfig({
    componentId: "sc-39b31ae8-2"
})([
    "z-index:2;height:0;position:absolute;top:4px;right:4px;"
]);
var FullWidthWrapper = styled(Column).withConfig({
    componentId: "sc-39b31ae8-3"
})([
    "height:100%;width:100%;"
]);
export var LeanBrandTileRendererBase = observer(LeanBrandTileRendererBaseCore);
